export class PaypalPromoCodeModal {
    id: string;
    promoName: string;
    productId: string;
    productName: string;
    promoCodeType: number;
    discountType: number;
    promoExpiry: string;
    promoUsage: number
    discountPercentage: number;
    discountAmountUpto: number;
    discountFixedAmount: number;
    minimumAmount: number;
    licensesCount: number;
    licenseDays: number;
    isUsed: boolean;
    promoExpiryDate: string;
    reedemCount: string;
    isExpired: boolean;
    paypalModal: PaypalPromoCodeModal[];
    updateDate: string;
    productAmount: number;
}
